// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"6c262acb","400":"75250030","473":"75250030","821":"33a5540c"}[chunkId] + ".chunk.css";
};